import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { InteractiveTutorialStep } from './types'

type TutorialState = {
  steps: InteractiveTutorialStep[]
  currentStep: number | null
}

const initialState: TutorialState = {
  steps: [],
  currentStep: null,
}

const tutorialSlice = createSlice({
  name: 'tutorial',
  initialState,
  reducers: {
    setSteps: (state, action: PayloadAction<InteractiveTutorialStep[]>) => {
      state.steps = action.payload
    },
    setCurrentStep: (state, action: PayloadAction<number | null>) => {
      state.currentStep = action.payload
    },
    reset: () => initialState,
  },
})

export const { actions, reducer: tutorial } = tutorialSlice
export const { setSteps, setCurrentStep, reset } = actions
